<template>
    <footer :class="$style.wrapper">
        <div :class="$style.inner">
            <div><img src="@/assets/applied_logo_master_white.svg" :class="$style.logo" alt="Applied logo" /></div>
            <div>
                Copyright © {{getYear}} Be Applied Ltd.
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'Footer',
    computed: {
        getYear(){
            return new Date().getFullYear()
        }
    }
}
</script>

<style module src="./Footer.css" />
